import React from 'react'
import AdminHeader from '../AdminHeader'
import AdminFooter from '../AdminFooter'

const LayoutBuyerSeller = ({ children }) => {
  return (
    <div className="w-full bg-esbgColor flex flex-col">
      <AdminHeader />
      <main className="flex-1 max-w-[1512px] py-8 md:px-16 2xl:px-8 mx-auto w-full">
        {children}
      </main>
      <AdminFooter />
    </div>
  )
}

export default LayoutBuyerSeller


